import { app } from '../app.module'
app
  /**
   * capitalize 例: facebook -> Facebook
   * @param {string} text 入力値
   * @return {string}
   */
  .filter('capitalize', () => {
    return function (text: string) {
      if (text === undefined || text === null) {
        return ''
      }
      return text.charAt(0).toUpperCase() + text.slice(1)
    }
  })
